module.exports = __webpack_public_path__ + "static/media/ETH.55fb49c7.svg";